'use client';

import { FC, ReactNode } from 'react';
import { EmptyStateProps } from './EmptyState.types';
import { Text, Flex } from '@/_components';
import styles from './EmptyState.module.css';
import {
  File,
  Chats,
  Pulse,
  Signature,
  Notebook,
  User,
  Receipt,
} from '@phosphor-icons/react';

export const EmptyState: FC<EmptyStateProps> = ({
  description = 'Nothing found',
  icon = 'user',
  children,
}) => {
  const getIcon = (): ReactNode => {
    if (icon === 'user') return <User size={52} fill="light" />;
    if (icon === 'questionnaire') return <Notebook size={52} fill="light" />;
    if (icon === 'file') return <File size={52} fill="light" />;
    if (icon === 'signature') return <Signature size={52} fill="light" />;
    if (icon === 'message') return <Chats size={52} fill="light" />;
    if (icon === 'pulse') return <Pulse size={52} fill="light" />;
    if (icon === 'receipt') return <Receipt size={52} fill="light" />;

    return null;
  };

  const iconRender: ReactNode = getIcon();

  return (
    <Flex isColumn={true} padding={24} gap={8} isCentered={true}>
      <Flex
        isColumn={true}
        isCentered={true}
        className={styles.emptyState__tile_container}
      >
        <Flex className={styles.emptyState__tile} isCentered={true}>
          {iconRender}
        </Flex>
        <span className={styles.emptyState__tile__dot1} />
        <span className={styles.emptyState__tile__dot2} />
        <span className={styles.emptyState__tile__dot3} />
        <span className={styles.emptyState__tile__dot4} />
        <span className={styles.emptyState__tile__dot5} />
      </Flex>
      <Flex isColumn={true} gap={10} isCentered={true}>
        <Text fontWeight="medium">{description}</Text>
        {children}
      </Flex>
    </Flex>
  );
};
